<template>
  <div>
    <app-header />

    <div class="container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="'/project/' + project.id">{{
              project.name
            }}</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ _lang("Redirects") }}
          </li>
        </ol>
      </nav>

      <router-link
        v-show="route.match(/\/redirects\/?$/)"
        :to="'/project/' + project.id + '/redirects/new'"
        class="btn btn-primary"
        >Novo</router-link
      >

      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import appHeader from "../components/appHeader.vue";

export default {
  name: "project",
  props: ["project_id"],
  components: {
    appHeader,
  },
  data() {
    return {};
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
		    route() {
      return location.pathname;
    },

  },
  mounted() {
    if (!this.project.id) {
      this.$store.dispatch("getProject", this.project_id);
    }
  },
};
</script>
